import React, { Component } from 'react';

import { Footer, Button, Link, Input, ContentHeader } from '../../General';
import { ChallengeReply } from '../../Challenge';
import { graphQLFetch, drawBullet, sendAnalytics } from '../../../helpers';

import './ChallengeScreen.css';
import logo from '../../../images/logo.svg';
import queries from './queries';

import img1 from '../../../images/challenges/thibault_cropped.png';
import img2 from '../../../images/challenges/marie_cropped.png';

class AtelierWatt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newReplyReplyId: null,
      descriptionShort: '',
      showMore: false,
      challengeReplies: null
    };

    this.upvoteReply = this.upvoteReply.bind(this);
    this.addReplyReply = this.addReplyReply.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
    this.getChallengeReplies = this.getChallengeReplies.bind(this);
  }

  componentDidMount() {
    this.getChallengeReplies(3);

    sendAnalytics(this.props);
  }

  componentDidUpdate(prevProps) {
    // This element only exists after fetching data, that's why we check in componentDidUpdate
    if (window.location.hash === '#antwoorden') {
      const antwoorden = document.getElementById('antwoorden');
      if (antwoorden) {
        antwoorden.scrollIntoView({
          block: 'start',
          inline: 'nearest',
          behavior: 'instant'
        });
      }
    }

    if (this.props.location !== prevProps.location) {
      sendAnalytics(this.props);
    }
  }

  scrollToReplies() {
    const antwoorden = document.getElementById('antwoorden');
    if (antwoorden) {
      antwoorden.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      });
    }
  }

  scrollToTop(e) {
    // window.scroll({ top: 0, behavior: 'smooth' });

    const top = document.getElementById('root');
    if (top) {
      top.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  }

  upvoteReply(id) {
    let votedFor = JSON.parse(localStorage.getItem('votedFor'));

    if (!votedFor) votedFor = [];
    if (votedFor.indexOf(id) !== -1) {
      return;
    }

    votedFor.push(id);
    localStorage.setItem('votedFor', JSON.stringify(votedFor));

    return graphQLFetch(queries.upvoteReplyQuery(id))
      .then(() => {
        this.getChallengeReplies(3);
      })
      .catch(err => {
        console.log(err);
      });
  }

  addReplyReply(challengeId, text, token) {
    if (token) {
      return graphQLFetch(
        queries.addReplyReplyQueryByCompany(challengeId, text, token)
      )
        .then(replyReplyJson => {
          this.getChallengeReplies(3, replyReplyJson.data.addReplyReply.id);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      return graphQLFetch(queries.addReplyReplyQuery(challengeId, text))
        .then(replyReplyJson => {
          this.getChallengeReplies(3, replyReplyJson.data.addReplyReply.id);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  getChallengeReplies(challengeId, newReplyReplyId = null) {
    graphQLFetch(queries.getChallengeRepliesQuery(challengeId)).then(json => {
      if (!json.data.challengeReplies) {
        throw Error('Geen antwoorden gevonden');
      }

      this.setState({
        challengeReplies: json.data.challengeReplies,
        newReplyReplyId
      });
    });
  }

  handleDescriptionChange(e) {
    this.setState({ descriptionShort: e.target.value });
  }

  render() {
    const challengeReplies = this.state.challengeReplies;

    if (this.state.error) return <p>Er is iets misgegaan :(</p>;

    return (
      <div>
        <div className="ChallengeScreen_ container">
          <Link to="/">
            <img
              src={logo}
              alt="Logo"
              className="ChallengeScreen_header_logo"
            />
          </Link>

          <div className="ChallengeScreen_header">
            <p className="ChallengeScreen_header_title">
              Hoe kunnen wij ons restmateriaal een duurzame bestemming geven?
            </p>

            <Input
              multiline
              placeholder="Mijn idee of mening hierover is..."
              onChange={this.handleDescriptionChange}
            />

            <Button
              iconRight="ion-ios-arrow-forward"
              link={{
                pathname: `/challenge/3/antwoord`,
                state: {
                  descriptionShort: this.state.descriptionShort
                }
              }}
            >
              Verstuur je idee
            </Button>

            {challengeReplies && challengeReplies.length === 0 ? null : (
              <a onClick={this.scrollToReplies}>
                Ontdek anderen hun ideeën
              </a>
            )}
          </div>

          <div className="ChallengeScreen_two-cols">
            <div className="ChallengeScreen_col-left">
              <div className="ChallengeScreen_col-left_rotated">
                <img
                  src={img1}
                  alt="Thibault van Atelier Watt."
                  className={'ChallengeScreen_col-left_img-rotated'}
                />
              </div>
            </div>
            <div>
              <ContentHeader>
                Waarom willen Marie en Thibault dit weten?
              </ContentHeader>
              <p>
                Als ontwerpbureau maken wij op bestelling maatwerk met
                hoogwaardige materialen.
                <br />
                Onvermijdelijk genereert dat restmateriaal, dat weliswaar van
                goede kwaliteit is maar dat wij door de beperkte afmetingenen of
                grillige vorm niet verder kunnen gebruiken.
                <br />
                <br />
                <strong>
                  Als duurzaam en ecologisch bewust atelier zouden wij het
                  jammer vinden om dit restmateriaal zomaar verloren te laten
                  gaan.
                </strong>
                <br />
                <br />
                Daarom zijn we op zoek naar ideeën om een nieuwe bestemming te
                geven aan deze stukken.
              </p>
              <p className="ChallengeScreen_vcenter">
                {drawBullet()}
                &nbsp; Elk idee maakt kans op een circulair cadeautje!
              </p>
              <p className="ChallengeScreen_idea-link">
                <a onClick={this.scrollToTop}>
                  Ik heb een idee!
                </a>
              </p>
            </div>
          </div>

          {challengeReplies && challengeReplies.length > 0 ? (
            <ContentHeader id="antwoorden">
              Anderen denken er zo over
            </ContentHeader>
          ) : null}
          <div className="ChallengeScreen_replies">
            {challengeReplies &&
              challengeReplies.map((reply, i) => {
                return this.state.showMore || i < 3 ? (
                  <ChallengeReply
                    key={reply.id}
                    reply={reply}
                    active={true}
                    votedFor={JSON.parse(localStorage.getItem('votedFor'))}
                    onUpvote={() => {
                      this.upvoteReply(reply.id);
                    }}
                    onReply={text => {
                      this.addReplyReply(
                        reply.id,
                        text,
                        localStorage.getItem('token')
                      );
                    }}
                    newReplyReplyId={this.state.newReplyReplyId}
                  />
                ) : null;
              })}
          </div>

          {!this.state.showMore &&
          challengeReplies &&
          challengeReplies.length > 0 &&
          challengeReplies.length > 3 ? (
            <Button
              onClick={() => this.setState({ showMore: true })}
              iconRight="ion-ios-arrow-down"
            >
              Toon alle ideeën
            </Button>
          ) : null}

          <ContentHeader>Over Atelier Watt</ContentHeader>
          <div className="ChallengeScreen_two-cols">
            <div>
              <div className="ChallengeScreen_light-text">
                <p>
                  Atelier Watt is een ontwerpbureau met atelier in Gent.
                  <br />
                  Iedereen met een tof idee is welkom bij ons!
                  <br />
                  <br />
                  Wij bieden maatwerk aan voor bedrijven en particulieren, maar
                  voorzien ook kleinschalige productie voor ontwerpers.
                  <br />
                  <br />
                  Onze focus ligt op <strong>duurzaam ondernemen</strong>: zowel
                  sociaal als ecologisch.
                  <br />
                  Van idee tot uitvoering: het kan lokaal bij Atelier Watt met
                  duurzame materialen!
                </p>
                <p>
                  <i className="icon ion-ios-globe" /> &nbsp;Regio: Gent
                </p>
                <p>
                  <i className="icon ion-ios-link" /> &nbsp;
                  <a
                    href="https://www.atelierwatt.be/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    atelierwatt.be
                  </a>
                </p>
              </div>
            </div>
            <div className="ChallengeScreen_col-right">
              <img
                src={img2}
                alt="Marie van Atelier Watt."
                className="ChallengeScreen_col-right_img"
              />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default AtelierWatt;
